import axios from 'axios';

import { JsonResponse } from 'core/models/response';
import { PublicAssemblySummary } from '../models/assemblySummary';

export const onGetPublicAssemblySummary = async (request_number: string) => {
	try {
		const response = await axios.get<JsonResponse<PublicAssemblySummary>>(`public/attendance-voting-summary/${request_number}`);
		return response.data.data;
	} catch (error) {
		throw error;
	}
};
